'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

/**
 * Brandfolder icon font. Uses https://icomoon.io/.
 */ const iconFont = styled.css`
  @font-face {
    font-family: 'bff';
    font-display: swap;
    src: url('https://fonts.brandfolder.com/bff-2.58/bff.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
  }
`;
/**
 * Brandfolder fonts. Uses https://lineto.com/typefaces/circular.
 */ const circularFonts = styled.css`
  @font-face {
    font-family: 'Circular-Bold';
    font-display: swap;
    src: url('https://fonts.brandfolder.com/circular/lineto-circular-bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Circular-Book';
    font-display: swap;
    src: url('https://fonts.brandfolder.com/circular/lineto-circular-book.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Circular-Medium';
    font-display: swap;
    src: url('https://fonts.brandfolder.com/circular/lineto-circular-medium.woff2') format('woff2');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Circular-Italic';
    font-display: swap;
    src: url('https://fonts.brandfolder.com/circular/lineto-circular-bookitalic.woff2')
      format('woff2');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Circular-Italic-Medium';
    font-display: swap;
    src: url('https://fonts.brandfolder.com/circular/lineto-circular-mediumitalic.woff2')
      format('woff2');
    font-weight: 500;
    font-style: italic;
  }
`;

exports.circularFonts = circularFonts;
exports.iconFont = iconFont;
//# sourceMappingURL=font-face.js.map
